import {formConstants} from "./constants";
import {onSnapshot} from "mobx-state-tree";

export function getFilterSnapshot(self, filterKey = "advFilterSelectState") {
  return {
    group: self.groupFilterSelectState?.selected ?? [],
    dimension: self.dimensionSelectViewState?.dimensionSelectStates?.map(select => select.selected) ?? [],
    filter: self[filterKey]?.selected ?? null,
    tags: self.tagFilterSelectState?.selected ?? null,
    isFilterTypeOR: self.isFilterTypeOR,
    isFilterVisible: self.isFilterVisible,
    searchTxt: self.searchTxt,
    perPage: self.listModel?.perPage ?? self.setStore?.perPage ?? self.store?.perPage,
  };
}


export function persistFiltersToSession(self, sessionKey, filterKey = "advFilterSelectState") {
  const snapshot = getFilterSnapshot(self, filterKey);
  sessionStorage.setItem(sessionKey, JSON.stringify(snapshot));
}


export function loadFiltersFromSession(self, sessionKey, filterKey = "advFilterSelectState") {
  const saved = sessionStorage.getItem(sessionKey);
  if (!saved) return;

  try {
    const filters = JSON.parse(saved);
    const keyMapping = {
      group: "groupFilterSelectState",
      tags: "tagFilterSelectState",
      filter: filterKey,
      dimension: "dimensionSelectViewState",
    };

    Object.entries(filters).forEach(([key, value]) => {
      const stateKey = keyMapping[key];

      if (key === "dimension" && Array.isArray(value)) {
        value.forEach((val, idx) => {
          self.dimensionSelectViewState?.dimensionSelectStates?.[idx]?.setSelected(val);
        });
      } else if (stateKey && typeof self[stateKey]?.setSelected === "function") {
        if (value) {
          const isMediaFilterDisabled = self[stateKey]?.enableMediaFilter === false;
          if (isMediaFilterDisabled && Array.isArray(value)) {
            const filteredValue = value.filter(item => {
              if (!item?.value) return true;
              const fieldName = item.value.split('.')[0];
              return !['fileFormat', 'status', 'usage'].includes(fieldName);
            });
            self[stateKey].setSelected(filteredValue);
          } else {
            self[stateKey].setSelected(value);
          }
        }
      } else if (key === "isFilterTypeOR") {
        self.isFilterTypeOR = value;
      } else if (key === "isFilterVisible") {
        self.isFilterVisible = value;
      } else if (key === "searchTxt") {
        self.searchTxt = value;
      } else if (key === "perPage") {
        self.listModel?.updatePerPage(value);
        self.setStore?.updatePerPage(value);
        self.store?.updatePerPage(value);
      }
    });
  } catch (e) {
    console.error("Error parsing session filters:", e);
  }
}


export function clearAllFilters(self, sessionKey, filterKey = "advFilterSelectState") {
  try {
    self.groupFilterSelectState?.reset?.();
    self.dimensionSelectViewState?.reset?.();
    self[filterKey]?.reset?.();
    self.tagFilterSelectState?.reset?.();
    // self.isFilterVisible = false;
    self.isFilterTypeOR = true;
    self.searchTxt = "";
    self.store?.updatePerPage?.(10);
    self.setStore?.updatePerPage?.(10);
    self.listModel?.updatePerPage?.(10);

    // Clear search parameters
    if (self.store?.searchParams) {
      self.store.searchParams = {};
    }
    if (self.listModel?.searchParams) {
      self.listModel.searchParams = {};
    }
    if (self.setStore?.searchParams) {
      self.setStore.searchParams = {};
    }

    // Refresh data
    if (self.isElasticSearchEnabled) {
      self.search?.();
    } else {
      self.refresh?.();
    }

    sessionStorage.removeItem(sessionKey);
  } catch (e) {
    console.error("Error while clearing filters:", e);
  }
}


export function applySearchParamsFromFilters(self, filterKey = "advFilterSelectState") {
  const searchParams = {
    groupUuid: self.groupFilterSelectState?.selected?.map(row => row.value?.split("groupUuid.")[1]).join(","),
    tags: self.tagFilterSelectState?.selected?.map(row => row.value?.split("tags.")[1]).join(","),
    q: self.searchTxt || "",
    tagFilterType: self.isFilterTypeOR ? formConstants.Mode.OR : formConstants.Mode.AND,
  };

  self[filterKey]?.selected?.forEach(({ value }) => {
    const [key, val] = value?.split(".") || [];
    if (key && val) {
      searchParams[key] = searchParams[key]
        ? `${searchParams[key]},${val}`
        : val;
    }
  });

  self.dimensionSelectViewState?.dimensionSelectStates?.forEach(selectState => {
    selectState.selected?.forEach(({ value }) => {
      const [, raw] = value?.split("dimensions.") || [];
      const [uuid, val] = raw?.split("_") || [];
      if (uuid && val) {
        const key = `dimension[${uuid}]`;
        searchParams[key] = searchParams[key]
          ? `${searchParams[key]},${val}`
          : val;
      }
    });
  });

  Object.keys(searchParams).forEach(key => {
    if (!searchParams[key]) delete searchParams[key];
  });

  if (Object.keys(searchParams).length) {
    self.store?.addSearchParams?.(searchParams);
    self.listModel?.addSearchParams?.(searchParams);
    console.log("Updated search params:", searchParams);
  }
}

export function registerInitialFilterSnapshot(viewState, sessionKey, filterKey = "advFilterSelectState") {
  onSnapshot(viewState, (snapshot) => {
    const existingFilters = sessionStorage.getItem(sessionKey);
    if (existingFilters) return;

    const filterSnapshot = {
      group: snapshot.groupFilterSelectState?.selected ?? [],
      dimension: snapshot.dimensionSelectViewState?.selected ?? null,
      filter: snapshot[filterKey]?.selected ?? null,
      tags: snapshot.tagFilterSelectState?.selected ?? null,
      searchTxt: snapshot.searchTxt,
      isFilterTypeOR: snapshot.isFilterTypeOR,
      isFilterVisible: snapshot.isFilterVisible,
      perPage: snapshot.store?.perPage,
    };

    console.log(`[filterSnapshot] Saving to ${sessionKey}:`, filterSnapshot);
    sessionStorage.setItem(sessionKey, JSON.stringify(filterSnapshot));
  });
}


